import { Navigate } from 'react-router-dom';

/**
 * Deprecated alias — MCP servers are now a tab inside Tool Providers.
 * Keeps /mcp-server bookmarks working by redirecting to the unified list
 * with the MCP filter pre-selected. The `/mcp` platform MCP server
 * (services/mcpServer.js) is unrelated — see docs/PUBLIC-API.md.
 */
export default function McpServersPage() {
  return <Navigate to="/app-tool-provider?kind=mcp" replace />;
}
